import { useState } from 'react';
import { Link, NavLink } from 'react-router-dom';
import { AnimatePresence, motion } from 'framer-motion';
import { Menu, X } from 'lucide-react';
import Brand from '../brand/Brand';
import { navItems } from '../../data/siteContent';

function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  function closeMenu() {
    setIsMenuOpen(false);
  }

  return (
    <header className="site-header">
      <Link className="brand-button" to="/" aria-label="Go to home" onClick={closeMenu}>
        <Brand compact />
      </Link>

      <nav className="site-nav desktop-nav" aria-label="Main navigation">
        {navItems.map((item) => (
          <NavLink
            key={item.path}
            className={({ isActive }) => (isActive ? 'nav-link nav-link-active' : 'nav-link')}
            end={item.path === '/'}
            to={item.path}
          >
            {item.label}
          </NavLink>
        ))}
      </nav>

      <button
        className="mobile-menu-toggle"
        type="button"
        onClick={() => setIsMenuOpen(true)}
        aria-label="Open menu"
        aria-expanded={isMenuOpen}
      >
        <Menu size={24} />
      </button>

      <AnimatePresence>
        {isMenuOpen && (
          <>
            <motion.button
              className="mobile-menu-backdrop"
              type="button"
              aria-label="Close menu"
              onClick={closeMenu}
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              exit={{ opacity: 0 }}
            />
            <motion.aside
              className="mobile-drawer"
              aria-label="Mobile navigation"
              initial={{ x: '100%' }}
              animate={{ x: 0 }}
              exit={{ x: '100%' }}
              transition={{ duration: 0.28, ease: 'easeOut' }}
            >
              <div className="mobile-drawer-head">
                <Brand compact />
                <button type="button" onClick={closeMenu} aria-label="Close menu">
                  <X size={23} />
                </button>
              </div>
              <nav className="mobile-drawer-nav" aria-label="Mobile menu">
                {navItems.map((item) => (
                  <NavLink
                    key={item.path}
                    className={({ isActive }) => (isActive ? 'drawer-link drawer-link-active' : 'drawer-link')}
                    end={item.path === '/'}
                    to={item.path}
                    onClick={closeMenu}
                  >
                    {item.label}
                  </NavLink>
                ))}
              </nav>
            </motion.aside>
          </>
        )}
      </AnimatePresence>
    </header>
  );
}

export default Header;
